import { toast } from "react-toastify";
import { endpoints } from "../../configs/Settings";
import { HTTPResponseStatus } from "../../utils/enum";
import { useAuth } from "../../utils/useAuth";
import { useAxios } from "../../utils/useAxios";

const filterDict: { [key: string]: string } = {
  "1": "cmed-type=Específico,Biológico,Produto de terapia avançada,Novo,Similar&cmed-product",
  "2": "cmed-substance",
  "3": "cmed-type=Genérico&cmed-substance",
};

export async function GetMedication(
  filter?: any,
  filterValue?: string,
  code?: string
) {
  let url = `${endpoints.TERMINOLOGY}/Medication`;
  if (filter && filterValue)
    url = `${url}?${[filterDict[filter]]}=${filterValue}&_count=250`;
  if (code) url = `${url}?code=${code}`;
  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };
  const response = await useAxios
    .get(url, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`GetMedication: ${response.status}`);
      }

      return { status: HTTPResponseStatus.Success, data: response.data };
    })
    .catch((error) => {
      console.error("GetMedication ", error);
      const errorMessage = error.code === 'ECONNABORTED' 
        ? `GetMedication Timeout: Requisição excedeu o tempo limite (${error.config.timeout}ms)`
        : `GetMedication Erro: ${error?.response?.status || error.message || 'Erro desconhecido'}`;
      console.error(errorMessage);
      // toast.error(errorMessage);
      throw new Error(errorMessage);
    });
  if (response) return response;
}
